import Siema from "siema";

export default class LimitSlider extends Siema {
  constructor(options) {
    super(options);

    this.refreshOffsetProperties();
    this.super = Object.getPrototypeOf(Object.getPrototypeOf(this));

    this.sigmoidMax = this.config.sigmoidMax || 80;
    this.sigmoidFactor = 300;
  }

  static bounds(val, min, max) {
    return Math.min(Math.max(min, val), max);
  }

  resolveSlidesNumber() {
    if (typeof this.config.perPage === "number") {
      this.perPage = LimitSlider.bounds(
        this.config.perPage,
        0,
        this.innerElements.length
      );
    } else if (typeof this.config.perPage === "object") {
      this.perPage = 1;

      Object.keys(this.config.perPage).forEach((viewport) => {
        if (window.innerWidth >= viewport) {
          this.perPage = LimitSlider.bounds(
            this.config.perPage[viewport],
            0,
            this.innerElements.length
          );
        }
      });
    }

    if (this.innerElements.length <= this.perPage) {
      this.selector.classList.add("no-scroll");
    } else {
      this.selector.classList.remove("no-scroll");
    }
  }

  refreshOffsetProperties() {
    this.perPage = LimitSlider.bounds(
      this.perPage,
      0,
      this.innerElements.length
    );

    const remainderItems =
      this.innerElements.length > this.perPage
        ? this.innerElements.length - this.perPage
        : 1;

    this.itemWidth = this.selectorWidth / this.perPage;
    this.maxOffset = this.itemWidth * remainderItems;
  }

  resizeHandler() {
    this.super.resizeHandler.call(this);

    this.refreshOffsetProperties();
  }

  sigmoid(num) {
    return (
      this.sigmoidMax * (2 / (1 + Math.E ** -(num / this.sigmoidFactor)) - 1)
    );
  }

  touchmoveHandler(e) {
    e.stopPropagation();

    if (this.innerElements.length <= this.perPage) return;

    if (this.drag.letItGo === null) {
      this.drag.letItGo =
        Math.abs(this.drag.startY - e.touches[0].pageY) <
        Math.abs(this.drag.startX - e.touches[0].pageX);
    }

    if (this.pointerDown && this.drag.letItGo) {
      e.preventDefault();
      this.drag.endX = e.touches[0].pageX;
      this.sliderFrame.style.webkitTransition = `all 0ms ${this.config.easing}`;
      this.sliderFrame.style.transition = `all 0ms ${this.config.easing}`;

      const currentSlide = this.config.loop
        ? this.currentSlide + this.perPage
        : this.currentSlide;
      const currentOffset = currentSlide * this.itemWidth;
      const dragOffset = this.drag.endX - this.drag.startX;
      let offset = this.config.rtl
        ? currentOffset + dragOffset
        : currentOffset - dragOffset;

      if (offset <= 0) {
        offset = this.sigmoid(offset);
      } else if (offset >= this.maxOffset) {
        offset = this.maxOffset + this.sigmoid(offset - this.maxOffset);
      }

      this.sliderFrame.style[this.transformProperty] = `translate3d(${
        (this.config.rtl ? 1 : -1) * offset
      }px, 0, 0)`;
    }
  }

  mousemoveHandler(e) {
    e.preventDefault();

    if (this.innerElements.length <= this.perPage) return;

    if (this.pointerDown) {
      // if dragged element is a link
      // mark preventClick prop as a true
      // to detemine about browser redirection later on
      const closestLink =
        e.target.closest("a") || document.createElement("div");
      if (closestLink.nodeName === "A") {
        this.drag.preventClick = true;
      }

      this.drag.endX = e.pageX;
      this.selector.style.cursor = "-webkit-grabbing";
      this.sliderFrame.style.webkitTransition = `all 0ms ${this.config.easing}`;
      this.sliderFrame.style.transition = `all 0ms ${this.config.easing}`;

      const currentSlide = this.config.loop
        ? this.currentSlide + this.perPage
        : this.currentSlide;
      const currentOffset = currentSlide * (this.selectorWidth / this.perPage);
      const dragOffset = this.drag.endX - this.drag.startX;
      let offset = this.config.rtl
        ? currentOffset + dragOffset
        : currentOffset - dragOffset;

      if (offset <= 0) {
        offset = this.sigmoid(offset);
      } else if (offset >= this.maxOffset) {
        offset = this.maxOffset + this.sigmoid(offset - this.maxOffset);
      }

      this.sliderFrame.style[this.transformProperty] = `translate3d(${
        (this.config.rtl ? 1 : -1) * offset
      }px, 0, 0)`;
    }
  }
}
